import { render, staticRenderFns } from "./ChildMembershipForm.vue?vue&type=template&id=2cb980c8"
import script from "./ChildMembershipForm.vue?vue&type=script&lang=js"
export * from "./ChildMembershipForm.vue?vue&type=script&lang=js"
import style0 from "./ChildMembershipForm.vue?vue&type=style&index=0&id=2cb980c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports